import React from "react";

const MenuSkeleton = () => (
  <div className="h-full bg-gray-50">
    {/* Header Skeleton */}
    <div className="bg-white border-b border-gray-300 p-4">
      <div className="animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-48"></div>
      </div>
    </div>

    <div className="p-4 space-y-4">
      {/* Main Grid Layout */}
      <div className="grid grid-cols-1 gap-4 lg:gap-6 lg:grid-cols-[280px_1fr] h-full">
        {/* Left Sidebar - Categories */}
        <div className="flex flex-col space-y-4">
          {/* Category Header */}
          <div className="flex items-center justify-between">
            <div className="animate-pulse">
              <div className="h-6 bg-gray-200 rounded w-20"></div>
            </div>
            <div className="animate-pulse">
              <div className="h-[38px] w-32 bg-gray-200 rounded-md"></div>
            </div>
          </div>

          {/* Category List */}
          <div className="space-y-2">
            {[...Array(6)].map((_, idx) => (
              <div key={idx} className="bg-white rounded-lg border border-gray-300 p-3">
                <div className="animate-pulse">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                      <div className="h-4 bg-gray-200 rounded w-24"></div>
                    </div>
                    <div className="flex space-x-1">
                      <div className="w-6 h-6 bg-gray-200 rounded"></div>
                      <div className="w-6 h-6 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="h-3 bg-gray-200 rounded w-16"></div>
                    <div className="w-12 h-6 bg-gray-200 rounded-full"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Food Items */}
        <div className="flex flex-col space-y-4">
          {/* Food Items Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="animate-pulse">
              <div className="h-6 bg-gray-200 rounded w-24"></div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              {/* Search Bar */}
              <div className="animate-pulse">
                <div className="h-[38px] w-full sm:w-80 bg-gray-200 rounded-lg"></div>
              </div>
              {/* Add Button */}
              <div className="animate-pulse">
                <div className="h-[38px] w-32 bg-gray-200 rounded-md"></div>
              </div>
              {/* View Toggle */}
              <div className="animate-pulse">
                <div className="h-[38px] w-20 bg-gray-200 rounded-md"></div>
              </div>
            </div>
          </div>

          {/* Food Items Grid/List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(9)].map((_, idx) => (
              <div key={idx} className="bg-white rounded-lg border border-gray-300 p-4">
                <div className="animate-pulse">
                  {/* Item Image */}
                  <div className="w-full h-32 bg-gray-200 rounded-lg mb-3"></div>
                  
                  {/* Item Details */}
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="h-5 bg-gray-200 rounded w-3/4"></div>
                      <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
                    </div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    <div className="flex justify-between items-center">
                      <div className="h-4 bg-gray-200 rounded w-16"></div>
                      <div className="flex space-x-1">
                        <div className="w-6 h-6 bg-gray-200 rounded"></div>
                        <div className="w-6 h-6 bg-gray-200 rounded"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const MenuLoader = ({ isLoading, children }) => {
  if (isLoading) {
    return <MenuSkeleton />;
  }
  return children;
};

export default MenuLoader; 